// extracted by css-extract-rspack-plugin
export default {"container":"TABRzRmWlA0uL5pl__container___"};